import axios from "axios";

export const getTaskTypes = (data, label) => {
  const requestUrl = `/team/task-types`;

  let filter = [];
  if (label && label.length > 0) {
    filter.push({
      property: "label",
      value: label,
      operator: "like"
    });
  }
  if (!data.firstCall) {
    if (data.categories && data.categories.length > 0) {
      filter.push({
        property: "category",
        value: data.categories,
        operator: data.categories.includes(null) ? "inOrNull" : "in"
      });
    }
  }

  let params = {
    sort: JSON.stringify([{ property: "category", dir: "asc" }]),
    filter: filter,
    organization: data.id
  };
  params.filter = JSON.stringify(filter).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );
  if (data.limited) {
    params.limit = data.pageSize || 10;
    params.start = !data.paginationPage
      ? 0
      : (data.paginationPage - 1) * data.pageSize;
  } else {
    params.nolimit = 1;
  }

  return axios.get(requestUrl, {
    params
  });
};

export const getNonCategorizedTaskTypeCount = ({ id }) => {
  const requestUrl = `/team/task-types`;

  let filter = [];
  filter = JSON.stringify([
    {
      property: "category",
      operator: "null"
    }
  ]).replace(/SPECIAL_CHAR_TO_REPLACE/g, "\\");

  let params = {
    filter: filter,
    nolimit: 1,
    organization: id
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getTaskCategories = id => {
  const requestUrl = `/team/task-categories`;

  let params = {
    organization: id
  };
  return axios.get(requestUrl, {
    params
  });
};

export const correlateTaskType = ({
  organizationId,
  categoryId,
  valuationId,
  actionOn,
  isBillable,
  data
}) => {
  const requestUrl = `/team/task-type/correlate`;

  var formData = new FormData();

  formData.append("data", data);
  formData.append("actionOn", actionOn);
  formData.append("categoryId", categoryId);
  formData.append("valuationId", valuationId);
  formData.append("organizationId", organizationId);
  formData.append("isBillable", isBillable);

  return axios.post(requestUrl, formData);
};

export const toggleBillableTask = ({ organizationId, id }) => {
  const requestUrl = `/team/task-type/billable`;

  let formData = new FormData();
  formData.append("organizationId", organizationId);
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/types.js